import logo from './logo.png';
import logo2 from './logo2.png';
import logo3 from './logo3.png';
import logoCaltex from './logoCaltex.jpeg';

export default {
  logo,
  logo2,
  logo3,
  logoCaltex,
};
